import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {catchError, concatMap, map} from 'rxjs/operators';
import {of} from 'rxjs';
import {
  loadProductionInstanceTypes,
  loadProductionInstanceTypesFailure,
  loadProductionInstanceTypesSuccess
} from './organization-account.production-instance-types.actions';
import {RegionCode} from '../../../services/api/account/regions/region.model';
import {InstanceTypesService} from '../../../services/api/account/instance-types/instance-types.service';
import {InstanceType} from '../../../services/api/account/instance-types/instance-type.model';


@Injectable()
export class OrganizationAccountProductionInstanceTypesEffects {

  // noinspection JSUnusedGlobalSymbols
  loadProductionInstanceTypes$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(loadProductionInstanceTypes),
        concatMap((parameters: { region: RegionCode }) => {
            return this.service.getProductionInstanceTypes(parameters.region)
              .pipe(
                map((data: InstanceType[]) => loadProductionInstanceTypesSuccess({data})),
                catchError((error: any) => of(loadProductionInstanceTypesFailure({error})))
              );
          }
        )
      );
  });


  constructor(
    private readonly actions$: Actions,
    private readonly service: InstanceTypesService
  ) {
  }

}
